import { gql } from '@apollo/client';
const UPDATE_WAREHOUSE_RELEASE_APPROVE = gql `
  mutation UpdateWarehouseReleaseApprove($warehouseReleaseNodeId: ID!) {
    approveWarehouseReleaseDraft(warehouseReleaseNodeId: $warehouseReleaseNodeId) {
      warehouseRelease {
        id
      }
    }
  }
`;
export default UPDATE_WAREHOUSE_RELEASE_APPROVE;
